// @Flow
import Vue from 'vue'
import type { B2bClientInterface } from '../../../services/b2b/b2b-client-interface'
import * as mutationTypes from './mutation-types'
import type {OrderSummary} from '../../../types/order-summary'

export default {
  loadOrders: async ({ commit, state }: { commit: (string, Array<OrderSummary>) => void }): Promise<void> => {
    const client: B2bClientInterface = Vue.prototype.$container.b2bClient
    try {
      const result = await client.getOrders(
        state.ordersCurrentPageNumber,
        state.ordersPageSize,
        state.ordersOrderBy,
        state.ordersOrderDirection
      )
      commit(mutationTypes.SET_ORDERS_FOR_CURRENT_FILTER, result.items)
      commit(mutationTypes.SET_TOTAL_NO_ORDERS_FOR_CURRENT_FILTER, result.count)
    } catch (e) {
      commit(mutationTypes.SET_ORDERS_FOR_CURRENT_FILTER, [])
      throw e
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/order/actions.js